<template>
  <div class="kpis">
    <StatisticsKpi label="CA facturé HT" :value="money(k.invoicedHt.value)" :growth="k.invoicedHt.growth" :previous="money(k.invoicedHt.previous)" />
    <StatisticsKpi label="CA encaissé HT" :value="money(k.collectedHt.value)" :growth="k.collectedHt.growth" :previous="money(k.collectedHt.previous)" />
    <StatisticsKpi label="Reste à encaisser TTC" :value="money(k.remainingToCollect)" hint="Factures émises sur la période" />
    <StatisticsKpi label="Factures en retard" :value="money(k.overdueAmount)" :hint="`${integer(k.overdueCount)} facture(s) échue(s) à ce jour`" :tone="k.overdueCount ? 'bad' : ''" />
    <StatisticsKpi label="Clients actifs" :value="integer(k.activeClients.value)" :growth="k.activeClients.growth" :previous="integer(k.activeClients.previous)" />
    <StatisticsKpi label="Nouveaux clients" :value="integer(k.newClients.value)" :growth="k.newClients.growth" :previous="integer(k.newClients.previous)" />
    <StatisticsKpi label="Devis créés" :value="integer(k.quotesCreated.value)" :growth="k.quotesCreated.growth" :previous="integer(k.quotesCreated.previous)" />
    <StatisticsKpi label="Taux de signature" :value="percent(k.signatureRate.value)" :growth="k.signatureRate.growth" :previous="percent(k.signatureRate.previous)" />
    <StatisticsKpi label="Panier moyen HT" :value="money(k.averageBasketHt.value)" :growth="k.averageBasketHt.growth" :previous="money(k.averageBasketHt.previous)" />
  </div>
  <div class="charts">
    <StatisticsCard :span="7" title="Chiffre d'affaires par période" :subtitle="`${revenueLabel(metric)} en barres, l'autre en pointillés`" :empty="!hasData(revenueValues)">
      <StatisticsChart :labels="labels" :datasets="revenueDatasets(data.series, metric)" />
    </StatisticsCard>
    <StatisticsCard :span="5" title="Facturé et encaissé cumulés" subtitle="L'écart entre les deux courbes est ce qu'il reste à encaisser" :empty="!hasData(revenueValues)">
      <StatisticsChart type="line" :labels="labels" :datasets="cumulativeDatasets" />
    </StatisticsCard>
  </div>
</template>

<script>
import StatisticsKpi from "@/statistics/components/StatisticsKpi.vue";
import StatisticsCard from "@/statistics/components/StatisticsCard.vue";
import StatisticsChart from "@/statistics/components/StatisticsChart.vue";
import {StatisticsService} from "@/statistics/services/StatisticsService";
import {bucketLabel, cumulative, hasData, integer, money, percent} from "@/statistics/utils/format";
import {PALETTE} from "@/statistics/utils/chartTheme";
import {revenueDatasets, revenueLabel} from "@/statistics/utils/revenue";

/**
 * Synthèse : les chiffres clés de la période comparés à la précédente, et le chiffre d'affaires dans le temps.
 */
export default {
  name: 'OverviewStats',
  components: {StatisticsKpi, StatisticsCard, StatisticsChart},
  props: {
    data: {type: Object, required: true},
  },
  computed: {
    k() {
      return this.data.kpis;
    },
    metric() {
      return StatisticsService.data.metric;
    },
    labels() {
      return this.data.series.map(row => bucketLabel(row.key));
    },
    revenueValues() {
      return this.data.series.flatMap(row => [row.invoicedHt, row.collectedHt]);
    },
    cumulativeDatasets() {
      return [
        {label: 'Facturé HT', data: cumulative(this.data.series.map(row => row.invoicedHt)), color: PALETTE[0], fill: true},
        {label: 'Encaissé HT', data: cumulative(this.data.series.map(row => row.collectedHt)), color: PALETTE[2]},
      ];
    },
  },
  methods: {money, integer, percent, hasData, revenueDatasets, revenueLabel},
};
</script>

<style lang="stylus" scoped>
@require '~/src/statistics/style/statistics.styl';
</style>
